__turbopack_context__.v({
  "chevron": "side-nav-menu-module__Bfu5aG__chevron",
  "chevronExpanded": "side-nav-menu-module__Bfu5aG__chevronExpanded",
  "menu": "side-nav-menu-module__Bfu5aG__menu",
  "subItems": "side-nav-menu-module__Bfu5aG__subItems",
  "toggle": "side-nav-menu-module__Bfu5aG__toggle",
});
